const focusOpts = () => ({
  duration: 0.0,
  moneyshotConfig: {
    offset: 1.4,
  },
});

const outlineOpts = () => ({
  lineThickness: 0.0127,
  includePoints: false,
  color: '#000000',
});

const segmentsOutlineOpts = () => ({
  color: '#ff0000', // red
  lineThickness: 0.0254,
});

const textLengthsOpts = () => ({
  useBackground: false,
  useSprite: false,
  useTransparency: true,
  textColor: '#000000',
  hAlign: 'center',
  vAlign: 'center',
  includeOuterLoop: true,
  includeInnerLoops: false,
  useMetricSystem: false,
  minSegmentLength: 0.3048, // 30.48 centimeters
});

const annotationTextOpts = () => ({
  useSprite: false,
  useBackground: true,
  includeFace: true,
  includeEdges: false,
  includeOuterLoop: false,
  includeInnerLoops: false,
  textColor: '#FFFFFF',
  backgroundColor: '#000000',
});

const facadeTextOpts = () => ({
  useSprite: false,
  useBackground: true,
  useTransparency: false,
  includeFace: false,
  includeOuterLoop: true,
  includeInnerLoops: false,
  textColor: '#FFFFFF',
  backgroundColor: '#000000',
});

const visibilityOpts = () => ({
  coloring: true,
  visibleDoorVent: false,
  visibleAll: true,
});

export default {
  annotationTextOpts,
  facadeTextOpts,
  focusOpts,
  outlineOpts,
  segmentsOutlineOpts,
  textLengthsOpts,
  visibilityOpts,
};
